<template>
  <wrapper class="promotion-w">
    <div class="aflex" @click="show">
      <div class="title pf-medium">优惠</div>
      <!--优惠模块展示券，减，团，秒，赠-->
      <div class="p-list-w item">
        <div class="p-item" v-if="couponList.length > 0">
          <span class="p-tag">领券</span>
          <div class="p-context">
            <coupon-list :list="couponList"></coupon-list>
          </div>
          <i class="icon-show-more"></i>
        </div>

        <div
          class="p-item"
          v-for="(pItem, i) in newPromList"
          :key="i"
          @click="handleClicked(pItem)"
        >
          <template v-if="showCouponComponent(pItem)">
            <span class="p-tag">返券</span>
            <div class="p-context">
              <coupon-list :list="pItem.couponList" showName></coupon-list>
            </div>
            <i class="icon-show-more"></i>
          </template>
          <template v-else>
            <span class="p-tag">{{ getTitle(pItem) }}</span>
            <div class="p-context ui-nowrap">
              <span>{{ getPromotionName(pItem) }}</span>
            </div>
            <i :class="getRightIconClassName(pItem)"></i>
          </template>
        </div>
        <!-- <div class="p-item">
          <span class="p-tag">赠品</span>
          <div class="p-context ui-nowrap">
            <span
              >满5000元赠小米体重秤一台满5000元赠小米体重秤一台满5000元赠小米体重秤一台</span
            >
          </div>
          <i class="icon-show-more"></i>
        </div>
        <a class="p-item">
          <span class="p-tag">拼团</span>
          <div class="p-context ui-nowrap">
            <span>[2人团]女性专享产后体检康复</span>&nbsp;<span>19.8元</span>
          </div>
          <i class="icon-arrow-right"></i>
        </a> -->
      </div>
    </div>
    <PromotionPopup
      ref="ppp"
      :promList="promList"
      :mixPromList="mixPromList"
      :couponList="couponList"
      :go2Detail="go2Detail"
      v-if="fetchStatus"
    ></PromotionPopup>
  </wrapper>
</template>
<script>
import Wrapper from '../../wrapper'
import CouponList from '../../coupon/list'
import PromotionPopup from './popup'
import { createNamespacedHelpers } from 'vuex'
import B_COUPON from '@/business/coupon'
import {
  E_PROMOTION_TYPE,
  PROMOTION_TYPES,
  COUPON_RECEIVED_STATUS
} from '@/config'
import { isEmptyObject, isNonEmptyArray, isNullOrEmpty } from '@/utils'
import { isFlashSalePage } from '@/router/home/new/product.bus'
const { mapState } = createNamespacedHelpers('promotionInfo')
export default {
  props: {
    spuId: [String, Number],
    skuId: [String, Number],
    businessId: [String, Number]
  },
  computed: {
    ...mapState(['promotionInfo']),
    fetchStatus() {
      return !isEmptyObject(this.promotionInfo)
    },
    mixPromList() {
      return this.promotionInfo.mixPromList
    },
    //返卷列表
    returnServiceCoupons() {
      if (
        this.promotionInfo &&
        this.promotionInfo.returnServiceCoupons &&
        this.promotionInfo.returnServiceCoupons.length > 0
      ) {
        return this.promotionInfo.returnServiceCoupons
          .filter(item => item.couponVoList && item.couponVoList.length > 0)
          .map(item => {
            return {
              type: E_PROMOTION_TYPE.RETURN_COUPON,
              couponList: item.couponVoList,
              minPayPrice: item.minPayPrice,
              starttime: item.starttime,
              endtime: item.endtime,
              orderState: item.orderState
            }
          })
      } else {
        return []
      }
    },
    //返现列表
    returnPurseList() {
      const list = this.promotionInfo.returnPurseList ?? []
      return list
        .filter(value => value != null)
        .map(item => {
          return {
            type: E_PROMOTION_TYPE.RETURN_CASH,
            promotionName: `宝宝钱包${item?.purseRechargeAmount / 100}元`,
            ...item
          }
        })
    },
    /**
     * 优惠模块展示券，减，团，秒，赠
     * 展示立减信息（立减金额），最多展示3个立减信息，超过3个的话拉起弹窗后展示
     * 如果多个规格有秒杀，优先展示最低价的秒杀，其他的拉起弹框后展示
     * 展示发放数量，实付金额限制，赠送礼品，只展示一个，多个的话拉起弹窗后展示
     *
     * 最优组合内有秒杀则不展示秒杀
     */
    newPromList() {
      let discountList = this.discountList.slice(0, 3)

      let flashSaleList = this.flashSaleList.slice(0, 1)

      // 如果促销活动内存在秒杀项，则最优组合内肯定有秒杀，则认为当前页面为秒杀，促销列表内就不展示秒杀，同时如果存在立减，则不展示立减模块
      if (isNonEmptyArray(flashSaleList)) {
        flashSaleList = []
        discountList = []
      }
      const rewardGiftList = this.rewardGiftList.slice(0, 1)
      const { xbuyEventList, groupBuyList } = this
      const list = [
        ...discountList,
        ...this.returnServiceCoupons,
        ...this.returnPurseList,
        ...xbuyEventList,
        ...groupBuyList,
        ...flashSaleList,
        ...rewardGiftList
      ]
      return list.slice(0, 1)
    },
    discountList() {
      return this.prePromList.filter(x => +x.type === E_PROMOTION_TYPE.DISCOUNT)
    },
    xbuyEventList() {
      return this.prePromList.filter(
        x => +x.type === E_PROMOTION_TYPE.XBUY_EVENT
      )
    },
    groupBuyList() {
      return this.prePromList.filter(
        x => +x.type === E_PROMOTION_TYPE.GROUP_BUY
      )
    },
    flashSaleList() {
      return this.prePromList
        .filter(x => +x.type === E_PROMOTION_TYPE.FLASH_SALE)
        .sort((a, b) => +a.orginprice - +b.orginprice)
    },
    rewardGiftList() {
      return this.prePromList.filter(
        x => +x.type === E_PROMOTION_TYPE.REWARD_GIFT
      )
    },
    promList() {
      let {
        discountList,
        flashSaleList,
        xbuyEventList,
        groupBuyList,
        rewardGiftList,
        returnPurseList,
        returnServiceCoupons
      } = this
      // 如果促销活动内存在秒杀项，则最优组合内肯定有秒杀，则认为当前页面为秒杀，促销列表内就不展示秒杀，同时如果存在立减，则不展示立减模块
      if (isNonEmptyArray(flashSaleList)) {
        discountList = []
      }

      return [
        ...discountList,
        ...returnServiceCoupons,
        ...returnPurseList,
        ...flashSaleList,
        ...xbuyEventList,
        ...groupBuyList,
        ...rewardGiftList
      ]
    },
    /**
     * 营销活动info
     */
    prePromList() {
      let list = this.promotionInfo.promList || []
      const route = this.$route
      let { ruleType = -1 } = route.query
      ruleType = +ruleType
      /**
       * 1.不在营销类型范围内的不展示
       * 2. 当前页已是秒杀页不展示
       * 3. 不展示正价
       * 4. 当前页已是秒杀页，如存在立减，则不展示立减模块
       * */
      return list
        .filter(
          x =>
            PROMOTION_TYPES.has(+x.type) &&
            +x.type !== E_PROMOTION_TYPE.POSITIVE_PRICE
        )
        .filter(x => {
          return !(isFlashSalePage(route) && ruleType === +x.type)
        })
        .filter(x => {
          return !(
            isFlashSalePage(route) && +x.type === E_PROMOTION_TYPE.DISCOUNT
          )
        })
    },
    couponList() {
      const list = this.promotionInfo.couponList || []
      /**
       * 不展示不可用券
       * 1.前端是否展示 isShow = 1
       * 2. 激活状态  status  1:待激活；2：生效；3：作废
       * 3. 券生效时间
       * */
      return list.filter(x => B_COUPON.isUseable(x))
    }
  },
  methods: {
    getTitle(promotionInfo) {
      return PROMOTION_TYPES.get(+promotionInfo.type)
    },
    showCouponComponent(promotionInfo) {
      let { type } = promotionInfo
      return E_PROMOTION_TYPE.RETURN_COUPON === +type
    },
    getPromotionName(promotionInfo) {
      let { type, promotionName, promotionPrice, allLimitNum, orginprice } =
        promotionInfo
      promotionPrice = promotionPrice / 100
      if (+type === E_PROMOTION_TYPE.FLASH_SALE)
        return `${promotionName} ${promotionPrice}元`
      if (+type === E_PROMOTION_TYPE.DISCOUNT) return `立减${promotionPrice}元`
      if (+type === E_PROMOTION_TYPE.REWARD_GIFT) return `${promotionName}`
      return promotionName
    },
    getRightIconClassName(promotionInfo) {
      // 秒杀和团购 use >
      const { type } = promotionInfo
      return this.isGroupBuy(type) || this.isXBuyEvent(type)
        ? 'icon-arrow-right'
        : 'icon-show-more'
    },
    handleClicked(pItem) {
      const { type } = pItem
      if (this.isGroupBuy(type) || this.isXBuyEvent(type)) {
        this.go2Detail(pItem)
      } else {
        this.show()
      }
    },
    isXBuyEvent(type) {
      return +type === E_PROMOTION_TYPE.XBUY_EVENT
    },
    isGroupBuy(type) {
      return (
        // +type === E_PROMOTION_TYPE.FLASH_SALE ||
        +type === E_PROMOTION_TYPE.GROUP_BUY
      )
    },
    go2Detail(item) {
      const { type, spuId, skuId, ruleId } = item
      if (+type === E_PROMOTION_TYPE.XBUY_EVENT) {
        location.href = `//life.cekid.com/v2/xbuy-event/${ruleId}?skuId=${skuId}`
        return
      }
      const { query: { empid = '', hserecomkey = '', businessId } = {} } =
        this.$route
      let pathName = ''

      // if (type === E_PROMOTION_TYPE.FLASH_SALE) {
      // pathName = 'product'
      // } else
      if (type !== E_PROMOTION_TYPE.GROUP_BUY) return

      pathName = 'groupBuy/groupInfo'

      let url = `/v/${pathName}/${spuId}?skuId=${skuId}&ruleId=${ruleId}&ruleType=${type}&empid=${empid}&hserecomkey=${hserecomkey}`
      if (businessId) {
        url += `&businessId=${businessId}`
      }
      location.href = url
    },
    async show() {
      // await this.$$ensureLogin()
      this.$refs['ppp'].show()
    }
  },
  components: {
    Wrapper,
    CouponList,
    PromotionPopup
  }
}
</script>

<style lang="scss" scoped src="./style.scss"></style>
